module.exports = __webpack_public_path__ + "media/customizations/bramlife/logo-480f0cae4f68ed48ff2a1d455e73686b.png";